export default __webpack_public_path__ + "static/media/plus-grey.c00ff620.svg";